import { Instance, SnapshotIn, types } from 'mobx-state-tree';

/**
 * FileUpload contains the particular data of a file, and some flags describing its status.
 */
export const FileUpload = types.model('FileUpload').props({
  name: types.string,
  type: types.string,
  uri: types.string,
  size: types.number,
  // set if an arror occours
  error: types.maybe(types.string),
  status: types.optional(types.enumeration(['pending', 'completed', 'failed']), 'pending'),
  // updated by progressCallback
  uploadedBytes: types.optional(types.number, 0),
  // assigned when response from backend is received
  fileUploadId: types.maybe(types.string),
});

export type IFileUpload = Instance<typeof FileUpload>;
// SnapshotIn, used for creating input to store: {Model}.create({})
export type IFileUploadSnapshotIn = SnapshotIn<typeof FileUpload>;
